// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__1z3WJ","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__1oWAf"};